import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e7a0cb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-one" }
const _hoisted_2 = { class: "card-body p-0 pe-8" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "mw-80" }
const _hoisted_5 = { class: "row mb-4" }
const _hoisted_6 = { class: "col-md-12 text-center" }
const _hoisted_7 = { class: "btn-group m-1" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-type-bold fs-2 text-primary" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-type-italic fs-2 text-primary" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-type-underline fs-2 text-primary" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "btn-group m-1" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-text-left fs-2 text-primary" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-text-center fs-2 text-primary" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-text-right fs-2 text-primary" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "btn-group m-1" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-type-h1 fs-2 text-primary" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-type-h2 fs-2 text-primary" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-type-h3 fs-2 text-primary" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "btn-group m-1" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise fs-2 text-primary" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-clockwise fs-2 text-primary" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-files fs-2 text-primary" }, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "row ma-4" }
const _hoisted_48 = { class: "table table-responsive align-middle fs-6 gy-3 table-bordered" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { colspan: "60" })
], -1))
const _hoisted_50 = {
  style: {"opacity":"0"},
  class: "myClass"
}
const _hoisted_51 = ["id"]
const _hoisted_52 = ["colspan", "rowspan"]
const _hoisted_53 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = ["colspan"]
const _hoisted_56 = { class: "col-md-12 text-center" }
const _hoisted_57 = { class: "init-id" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "init-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "init-content-inner" }, " Please click on + icon to draw table structure and then drag drop elements from right panel. ")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus" }, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 0,
  id: "controls",
  class: "w-500px"
}
const _hoisted_62 = { class: "card card-flush ms-5" }
const _hoisted_63 = {
  ref: "scrollControl",
  class: "card-body p-0",
  id: "kt_chat_contacts_body"
}
const _hoisted_64 = { class: "nav nav-pills nav-justified mb-5 d-none" }
const _hoisted_65 = { class: "nav-item" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Control")
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = {
  class: "h-lg-Designboxe",
  "data-kt-scroll": "false",
  "data-kt-scroll-activate": "{default: false, lg: fase}",
  "data-kt-scroll-dependencies": "#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header",
  "data-kt-scroll-wrappers": "#kt_content, #kt_chat_contacts_body",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_70 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_71 = { class: "w-100 list-boxes p-5 pb-0 border-dashed border-1 border-primary" }
const _hoisted_72 = { class: "row h-lg-Designboxeright scroll-y pe-1 align-content-start" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "border-bottom mb-2 pb-3 text-gray-800" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-ui-checks-grid fs-4 text-primary" })
    ])
  ]),
  /*#__PURE__*/_createTextVNode(" Controls ")
], -1))
const _hoisted_74 = { class: "d-flex flex-column" }
const _hoisted_75 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_76 = {
  class: "tab-pane fade show active",
  id: "fields",
  role: "tabpanel"
}
const _hoisted_77 = { class: "dual-list list-left col-sm-12 px-0" }
const _hoisted_78 = { class: "well text-right" }
const _hoisted_79 = { class: "list-group border-0" }
const _hoisted_80 = { class: "d-flex align-items-center position-relative my-4" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = ["id"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "presets",
  role: "tabpanel"
}, " Content Preset ", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "interface",
  role: "tabpanel"
}, " Content Interface ", -1))
const _hoisted_86 = { class: "scroll-y p-5 h-200px border-dashed border-primary border-1 h-lg-Designboxes" }
const _hoisted_87 = { class: "h-600px me-n3" }
const _hoisted_88 = { class: "d-flex justify-content-evenly" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn btn-sm bg-secondary btn-icon mb-2 mx-auto" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-trash-alt fs-2 text-danger" })
], -1))
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_91 = [
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn btn-sm bg-secondary btn-icon mb-2 mx-auto" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-copy fs-2 text-gray-800" })
], -1))
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" Duplicate ")
const _hoisted_94 = [
  _hoisted_92,
  _hoisted_93
]
const _hoisted_95 = /*#__PURE__*/_createStaticVNode("<div class=\"d-block pt-3\" data-v-7e7a0cb6><ul class=\"nav nav-tabs nav-line-tabs nav-line-tabs-2x nav-justified\" data-v-7e7a0cb6><li class=\"nav-item\" data-v-7e7a0cb6><a id=\"text-tab-link\" class=\"nav-link text-gray-600 active\" data-bs-toggle=\"tab\" href=\"#text-tab\" data-v-7e7a0cb6>Text</a></li><li class=\"nav-item\" data-v-7e7a0cb6><a id=\"appearance-tab-link\" class=\"nav-link text-gray-600\" data-bs-toggle=\"tab\" href=\"#appearance-tab\" data-v-7e7a0cb6>Appearance</a></li><li class=\"nav-item\" data-v-7e7a0cb6><a id=\"properties-tab-link\" class=\"nav-link text-gray-600\" data-bs-toggle=\"tab\" href=\"#properties-tab\" data-v-7e7a0cb6>Properties</a></li></ul></div>", 1)
const _hoisted_96 = {
  class: "tab-content pt-5",
  id: "myTabContent"
}
const _hoisted_97 = {
  class: "tab-pane fade show active",
  id: "text-tab",
  role: "tabpanel"
}
const _hoisted_98 = { class: "col-sm-12 pe-3" }
const _hoisted_99 = { class: "fv-row mb-3" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required mb-2" }, "Text", -1))
const _hoisted_101 = { class: "fv-row mb-3" }
const _hoisted_102 = { class: "form-check form-check-custom" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Use default fonts ", -1))
const _hoisted_104 = { class: "fv-row mb-3" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required mb-2" }, "Font Family", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Arial" }, "Arial", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Sans serif" }, "Sans serif", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Poppins" }, "Poppins", -1))
const _hoisted_109 = [
  _hoisted_106,
  _hoisted_107,
  _hoisted_108
]
const _hoisted_110 = { class: "fv-row mb-3" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required mb-2" }, "Font Size", -1))
const _hoisted_112 = { class: "fv-row mb-3" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required mb-2" }, "Font Weight", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "lighter" }, "Light", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "normal" }, "Normal", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bold" }, "Bold", -1))
const _hoisted_117 = [
  _hoisted_114,
  _hoisted_115,
  _hoisted_116
]
const _hoisted_118 = { class: "row mb-5" }
const _hoisted_119 = { class: "col-sm-6" }
const _hoisted_120 = { class: "form-check form-check-custom" }
const _hoisted_121 = ["checked"]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Italic ", -1))
const _hoisted_123 = { class: "col-sm-6" }
const _hoisted_124 = { class: "form-check form-check-custom" }
const _hoisted_125 = ["checked"]
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Underline ", -1))
const _hoisted_127 = { class: "fv-row mb-3" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required mb-2" }, "Text Color", -1))
const _hoisted_129 = { class: "input-group mb-5" }
const _hoisted_130 = {
  class: "tab-pane fade",
  id: "appearance-tab",
  role: "tabpanel"
}
const _hoisted_131 = { class: "col-sm-12 pe-3" }
const _hoisted_132 = { class: "fv-row mb-3" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required mb-2" }, "Background Color", -1))
const _hoisted_134 = { class: "input-group mb-5" }
const _hoisted_135 = { class: "fv-row mb-3" }
const _hoisted_136 = { class: "form-check form-check-custom" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Use default border ", -1))
const _hoisted_138 = { class: "fv-row mb-3" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required mb-2" }, "Border Style", -1))
const _hoisted_140 = /*#__PURE__*/_createStaticVNode("<option value=\"solid\" data-v-7e7a0cb6>Solid</option><option value=\"dashed\" data-v-7e7a0cb6>Dashed</option><option value=\"dotted\" data-v-7e7a0cb6>Dotted</option><option value=\"double\" data-v-7e7a0cb6>Double</option><option value=\"groove\" data-v-7e7a0cb6>Groove</option><option value=\"inset\" data-v-7e7a0cb6>Inset</option>", 6)
const _hoisted_146 = [
  _hoisted_140
]
const _hoisted_147 = { class: "fv-row mb-3" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required mb-2" }, "Border Width", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "thin" }, "Thin", -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "normal" }, "Normal", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "thick" }, "Thick", -1))
const _hoisted_152 = [
  _hoisted_149,
  _hoisted_150,
  _hoisted_151
]
const _hoisted_153 = { class: "fv-row mb-3" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required mb-2" }, "Border Color", -1))
const _hoisted_155 = { class: "input-group mb-5" }
const _hoisted_156 = { class: "row mb-4" }
const _hoisted_157 = { class: "col-sm-6" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "Padding", -1))
const _hoisted_159 = { class: "col-sm-6" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "Margin", -1))
const _hoisted_161 = {
  class: "tab-pane fade",
  id: "properties-tab",
  role: "tabpanel"
}
const _hoisted_162 = { class: "col-sm-12 pe-3" }
const _hoisted_163 = { class: "fv-row mb-3" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "ID", -1))
const _hoisted_165 = { class: "fv-row mb-3" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode("Class "),
  /*#__PURE__*/_createElementVNode("small", null, "(Add space for multiple classes)")
], -1))
const _hoisted_167 = { class: "row mb-3" }
const _hoisted_168 = { class: "col-sm-6" }
const _hoisted_169 = { class: "form-check form-check-custom" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Required ", -1))
const _hoisted_171 = { class: "col-sm-6" }
const _hoisted_172 = { class: "form-check form-check-custom" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Readonly ", -1))
const _hoisted_174 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_175 = { class: "col-sm-12" }
const _hoisted_176 = { class: "form-check form-check-custom" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "cameraOnly"
}, " Camera only ", -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-row mb-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label",
    for: "flexCheckChecked"
  }, " Mask ")
], -1))
const _hoisted_179 = { class: "fv-row mb-3" }
const _hoisted_180 = { class: "form-check form-check-custom" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-row mb-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, " Mask Message ")
], -1))
const _hoisted_182 = { class: "fv-row mb-3" }
const _hoisted_183 = { class: "form-check form-check-custom" }
const _hoisted_184 = { class: "fv-row mb-3" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "Points", -1))
const _hoisted_186 = { class: "fv-row mb-3" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "Operations", -1))
const _hoisted_188 = { class: "form-check form-check-custom" }
const _hoisted_189 = { class: "fv-row mb-3" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "Type", -1))
const _hoisted_191 = { class: "form-check form-check-custom" }
const _hoisted_192 = /*#__PURE__*/_createStaticVNode("<option value=\"Exit\" data-v-7e7a0cb6>Exit</option><option value=\"LateValidation\" data-v-7e7a0cb6> LateValidation </option><option value=\"Enable\" data-v-7e7a0cb6>Enable</option><option value=\"Disable\" data-v-7e7a0cb6>Disable</option><option value=\"Reset\" data-v-7e7a0cb6>Reset</option><option value=\"ColorCondition\" data-v-7e7a0cb6> ColorCondition </option><option value=\"CorrectiveAction\" data-v-7e7a0cb6> CorrectiveAction </option>", 7)
const _hoisted_199 = [
  _hoisted_192
]
const _hoisted_200 = { class: "fv-row mb-3" }
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "Expressions", -1))
const _hoisted_202 = { class: "form-check form-check-custom" }
const _hoisted_203 = { class: "fv-row mb-3" }
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "Data", -1))
const _hoisted_205 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_206 = { id: "basic-addon2" }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-white m-1 fs-4" }, null, -1))
const _hoisted_208 = [
  _hoisted_207
]
const _hoisted_209 = {
  key: 0,
  id: "basic-addon2"
}
const _hoisted_210 = ["onClick"]
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-white m-1 fs-4" }, null, -1))
const _hoisted_212 = [
  _hoisted_211
]
const _hoisted_213 = { class: "fv-row mb-3 pb-3" }
const _hoisted_214 = { class: "form-check form-check-custom" }
const _hoisted_215 = {
  ref: "scrollRef",
  class: "w-100 list-boxes p-5 border-dashed border-1 border-primary pb-0 rounded-0 h-lg-Designboxes overflow-auto"
}
const _hoisted_216 = { class: "row" }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "border-bottom mb-2 pb-3 text-gray-800" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-stars fs-3 text-primary" })
    ])
  ]),
  /*#__PURE__*/_createTextVNode(" sections ")
], -1))
const _hoisted_218 = { class: "dual-list list-left col-sm-12 px-0" }
const _hoisted_219 = { class: "well text-right" }
const _hoisted_220 = { class: "list-group border-0" }
const _hoisted_221 = { class: "d-flex align-items-center position-relative m-4" }
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_223 = ["id"]
const _hoisted_224 = { class: "d-flex align-items-center rounded bg-light-primary rounded p-4 mb-1" }
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-stars text-primary fs-2 me-3 mt-1" }, null, -1))
const _hoisted_226 = { class: "flex-grow-1 me-2" }
const _hoisted_227 = { class: "list-arrows" }
const _hoisted_228 = ["onClick"]
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-eye fs-6" }, null, -1))
const _hoisted_230 = [
  _hoisted_229
]
const _hoisted_231 = {
  key: 1,
  id: "edit",
  class: "w-500px collapse"
}
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card card-flush ms-5" }, null, -1))
const _hoisted_233 = [
  _hoisted_232
]
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "templates",
  class: "w-500px collapse"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card card-flush ms-5" })
], -1))
const _hoisted_235 = { class: "engage-toolbar d-flex position-fixed px-5 fw-bolder top-50 zindex-2 end-0 transform-90 mt-20 gap-2" }
const _hoisted_236 = /*#__PURE__*/_createTextVNode(" Controls ")
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-down-short fs-1 ms-2" }, null, -1))
const _hoisted_238 = [
  _hoisted_236,
  _hoisted_237
]
const _hoisted_239 = /*#__PURE__*/_createTextVNode(" Templates ")
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-down-short fs-1 ms-2" }, null, -1))
const _hoisted_241 = [
  _hoisted_239,
  _hoisted_240
]
const _hoisted_242 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-down-short fs-1 ms-2" }, null, -1))
const _hoisted_244 = [
  _hoisted_242,
  _hoisted_243
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DesignerHeader = _resolveComponent("DesignerHeader")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_DrawComponent = _resolveComponent("DrawComponent")!
  const _component_VZDropMessage = _resolveComponent("VZDropMessage")!
  const _component_EmptyContent = _resolveComponent("EmptyContent")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FormSectionModal = _resolveComponent("FormSectionModal")!
  const _component_MobilePreviewModal = _resolveComponent("MobilePreviewModal")!
  const _component_TabletPreviewModal = _resolveComponent("TabletPreviewModal")!
  const _component_TemplatePreviewModal = _resolveComponent("TemplatePreviewModal")!
  const _component_ContextMenu = _resolveComponent("ContextMenu")!
  const _component_DropComponentModal = _resolveComponent("DropComponentModal")!
  const _component_OverrideTableModal = _resolveComponent("OverrideTableModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DesignerHeader, {
        designCreated: _ctx.formStructure.length > 0,
        onGetPreviewData: _ctx.getPreviewData,
        onSaveData: _ctx.publishForm,
        onCreateTable: _ctx.showDialog,
        formSection: _ctx.formSection,
        isTemplate: _ctx.isTemplate,
        onConfirmDiscard: _ctx.confirmDiscard,
        onToggleIsTemplate: _ctx.toggleIsTemplate,
        disabled: _ctx.inProgressWebId === 0,
        loading: _ctx.loading
      }, null, 8, ["designCreated", "onGetPreviewData", "onSaveData", "onCreateTable", "formSection", "isTemplate", "onConfirmDiscard", "onToggleIsTemplate", "disabled", "loading"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["scroll-y p-5 h-200px border-dashed border-primary border-1 h-lg-Designboxes", {
              'h-lg-500px': _ctx.sideBarOption === 'TEMPLATES',
              'h-lg-Designboxes': _ctx.sideBarOption !== 'TEMPLATES',
            }]),
              "data-kt-element": "messages",
              "data-kt-scroll": "true",
              "data-kt-scroll-activate": "{default: false, lg: true}",
              "data-kt-scroll-dependencies": "#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer",
              "data-kt-scroll-wrappers": "#kt_content, #kt_chat_messenger_body",
              "data-kt-scroll-offset": "5px"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Bold",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.selectControl,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleStyles({ fontWeight: 'bold' }))),
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm"
                        }, _hoisted_10, 8, _hoisted_8)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Italic",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.selectControl,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleStyles({ fontStyle: 'italic' }))),
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm"
                        }, _hoisted_13, 8, _hoisted_11)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Underline",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.selectControl,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleStyles({ textDecoration: 'underline' }))),
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm"
                        }, _hoisted_16, 8, _hoisted_14)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Align Left",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.selectControlColumn,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.alignItems('start'))),
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm"
                        }, _hoisted_20, 8, _hoisted_18)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Align Center",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.selectControlColumn,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.alignItems('center'))),
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm"
                        }, _hoisted_23, 8, _hoisted_21)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Align Right",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.selectControlColumn,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.alignItems('end'))),
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm"
                        }, _hoisted_26, 8, _hoisted_24)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Heading 1",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.selectControl,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleStyles({ fontSize: '2em' }))),
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm"
                        }, _hoisted_30, 8, _hoisted_28)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Heading 2",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.selectControl,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleStyles({ fontSize: '1.5em' }))),
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm"
                        }, _hoisted_33, 8, _hoisted_31)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Heading 3",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.selectControl,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleStyles({ fontSize: '1.17em' }))),
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm"
                        }, _hoisted_36, 8, _hoisted_34)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Undo",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm",
                          disabled: !_ctx.canUndo && _ctx.history.length > 2,
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.undo && _ctx.undo(...args)))
                        }, _hoisted_40, 8, _hoisted_38)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Redo",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm",
                          disabled: !_ctx.canRedo,
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.redo && _ctx.redo(...args)))
                        }, _hoisted_43, 8, _hoisted_41)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    content: "Duplicate",
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.duplicateElement && _ctx.duplicateElement(...args))),
                        disabled: !_ctx.selectControl,
                        class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-sm m-1"
                      }, _hoisted_46, 8, _hoisted_44)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", {
                  id: "parent",
                  onContextmenu: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showContextMenu($event))),
                  onMousedown: _cache[21] || (_cache[21] = ($event: any) => (_ctx.selectColumn($event))),
                  "aria-haspopup": "true",
                  onDrop: _cache[22] || (_cache[22] = ($event: any) => (_ctx.drop($event))),
                  onDragover: _cache[23] || (_cache[23] = ($event: any) => (_ctx.allowDrop($event))),
                  class: "col-md-12"
                }, [
                  _createElementVNode("table", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MAX_BLOCKS, (n, index) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: index,
                            colspan: "1"
                          }))
                        }), 128))
                      ]),
                      (_ctx.formStructure.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formStructure, (row, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              dragover: "handleDragOver($event)",
                              id: row.key
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.columns, (col, colIndex) => {
                                return (_openBlock(), _createElementBlock("td", _mergeProps({
                                  key: colIndex,
                                  colspan: `${
                            (_ctx.MAX_BLOCKS / _ctx.spanInColumn[index]) * col.colSpan
                          }`,
                                  rowspan: col.rowSpan
                                }, col.attrs, {
                                  dragover: "handleDragOver($event)",
                                  style: {
                            background:
                              _ctx.selectedColumns.findIndex(
                                (item) => item === col.key
                              ) > -1
                                ? '#EAF9B6'
                                : '',
                          }
                                }), [
                                  _createElementVNode("div", _mergeProps({ class: "d-flex align-items-center" }, row.rowProp, {
                                    class: col.class,
                                    onDragstart: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleDragStart && _ctx.handleDragStart(...args))),
                                    onDragover: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleDragOver && _ctx.handleDragOver(...args))),
                                    onDragenter: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args))),
                                    onDragleave: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args))),
                                    onDragend: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleDragEnd && _ctx.handleDragEnd(...args))),
                                    onDrop: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args))),
                                    style: {"column-gap":"2em"}
                                  }), [
                                    (col.components.length > 0)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(col.components, (component, compIndex) => {
                                          return (_openBlock(), _createBlock(_component_DrawComponent, {
                                            key: compIndex,
                                            draggable: true,
                                            onDragstart: _ctx.handleDragStart,
                                            onDragover: _ctx.handleDragOver,
                                            onDragenter: _ctx.handleDragEnter,
                                            onDragleave: _ctx.handleDragLeave,
                                            onDragend: _ctx.handleDragEnd,
                                            onDrop: _ctx.handleDrop,
                                            onCustomEvent: _ctx.customEvent,
                                            component: component,
                                            selectControl: _ctx.selectControl
                                          }, null, 8, ["onDragstart", "onDragover", "onDragenter", "onDragleave", "onDragend", "onDrop", "onCustomEvent", "component", "selectControl"]))
                                        }), 128))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                          _createVNode(_component_VZDropMessage, {
                                            draggable: true,
                                            onDragstart: _ctx.handleDragStart,
                                            onDragover: _ctx.handleDragOver,
                                            onDragenter: _ctx.handleDragEnter,
                                            onDragleave: _ctx.handleDragLeave,
                                            onDragend: _ctx.handleDragEnd,
                                            onDrop: _ctx.handleDrop
                                          }, null, 8, ["onDragstart", "onDragover", "onDragenter", "onDragleave", "onDragend", "onDrop"])
                                        ]))
                                  ], 16)
                                ], 16, _hoisted_52))
                              }), 128))
                            ], 8, _hoisted_51))
                          }), 128))
                        : (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                            _createElementVNode("td", { colspan: _ctx.MAX_BLOCKS }, [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                  _hoisted_58,
                                  _createElementVNode("div", {
                                    class: "top-plus-icon",
                                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.showDialog && _ctx.showDialog(...args)))
                                  }, _hoisted_60)
                                ]),
                                _createVNode(_component_EmptyContent, {
                                  templateOptions: _ctx.templateOptions,
                                  showDialog: _ctx.showInitialDialog,
                                  onCreateTable: _ctx.createTable,
                                  onCloseInitialModal: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showInitialDialog = false))
                                }, null, 8, ["templateOptions", "showDialog", "onCreateTable"])
                              ])
                            ], 8, _hoisted_55)
                          ]))
                    ])
                  ])
                ], 32)
              ])
            ], 2)
          ]),
          (_ctx.formStructure.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _withDirectives(_createElementVNode("div", _hoisted_63, [
                    _createElementVNode("ul", _hoisted_64, [
                      _createElementVNode("li", _hoisted_65, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["nav-link active rounded-0 py-4", {
                      active: !_ctx.selectControl,
                    }]),
                          "aria-current": "page",
                          "data-bs-toggle": "tab",
                          href: "#add"
                        }, _hoisted_68, 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["tab-pane fade show active", {
                      active: !_ctx.selectControl,
                    }]),
                          id: "add",
                          role: "tabpanel"
                        }, [
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _hoisted_73,
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                      _createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("ul", _hoisted_79, [
                                          _createElementVNode("div", _hoisted_80, [
                                            _createElementVNode("span", {
                                              class: "svg-icon svg-icon-1 position-absolute ms-3",
                                              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.getFilteredControl && _ctx.getFilteredControl(...args)))
                                            }, _hoisted_82),
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              "data-kt-user-table-filter": "search",
                                              class: "form-control form-control-solid ps-14",
                                              placeholder: "Search here...",
                                              onKeyup: _cache[25] || (_cache[25] = 
                                          () => {
                                            if (
                                              _ctx.searchTermDropableComponent.length ==
                                                0 ||
                                              _ctx.searchTermDropableComponent.length >=
                                                3
                                            )
                                              _ctx.getFilteredControl();
                                          }
                                        ),
                                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.searchTermDropableComponent) = $event))
                                            }, null, 544), [
                                              [_vModelText, _ctx.searchTermDropableComponent]
                                            ])
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterdDroppableControls, (item, index) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                              draggable: true,
                                              onDragstart: _cache[28] || (_cache[28] = ($event: any) => (_ctx.dragElement($event))),
                                              id: item.id,
                                              class: "list-group-item bg-light-primary rounded p-5 mb-3",
                                              key: index
                                            }, [
                                              _createElementVNode("a", {
                                                onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"])),
                                                class: "d-flex fw-bolder text-gray-800 text-hover-primary fs-6"
                                              }, [
                                                _createElementVNode("i", {
                                                  class: _normalizeClass(["bi text-primary fs-2 me-3 align-bottom", `${item.icon}`])
                                                }, null, 2),
                                                _createTextVNode(" " + _toDisplayString(item.label), 1)
                                              ])
                                            ], 40, _hoisted_83))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _hoisted_84,
                                  _hoisted_85
                                ])
                              ])
                            ])
                          ])
                        ], 2)
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.sideBarOption === 'CONTROLS']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("a", {
                          class: "text-center d-grid fs-6 text-danger",
                          onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.deleteSelectedItem && _ctx.deleteSelectedItem(...args)))
                        }, _hoisted_91),
                        _createElementVNode("a", {
                          class: "text-center d-grid fs-6 text-gray-700",
                          onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.duplicateElement && _ctx.duplicateElement(...args)))
                        }, _hoisted_94)
                      ]),
                      _hoisted_95,
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _hoisted_100,
                              _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                rows: "3",
                                placeholder: "eg: this is text",
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.vzAttributes['text']) = $event)),
                                onKeyup: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                              }, null, 544), [
                                [_vModelText, _ctx.vzAttributes['text']]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("div", _hoisted_102, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.vzAttributes['defaultFonts']) = $event)),
                                  onChange: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                                }, null, 544), [
                                  [_vModelCheckbox, _ctx.vzAttributes['defaultFonts']]
                                ]),
                                _hoisted_103
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _hoisted_105,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.vzAttributes['fontFamily']) = $event)),
                                class: "form-select form-select-solid",
                                "data-placeholder": "Select option",
                                onChange: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                              }, _hoisted_109, 544), [
                                [_vModelSelect, _ctx.vzAttributes['fontFamily']]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_110, [
                              _hoisted_111,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control mb-3 mb-lg-0",
                                placeholder: "eg: 12px",
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.vzAttributes['fontSize']) = $event)),
                                onBlur: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                              }, null, 544), [
                                [_vModelText, _ctx.vzAttributes['fontSize']]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_112, [
                              _hoisted_113,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.vzAttributes['fontWeight']) = $event)),
                                class: "form-select form-select-solid",
                                "data-placeholder": "Select option",
                                onChange: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                              }, _hoisted_117, 544), [
                                [_vModelSelect, _ctx.vzAttributes['fontWeight']]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("div", _hoisted_119, [
                                _createElementVNode("div", _hoisted_120, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    onClick: _cache[41] || (_cache[41] = 
                                () => {
                                  _ctx.toggleStyles({ fontStyle: 'italic' });
                                }
                              ),
                                    checked: _ctx.isChecked('fontStyle', 'italic')
                                  }, null, 8, _hoisted_121),
                                  _hoisted_122
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_123, [
                                _createElementVNode("div", _hoisted_124, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    onClick: _cache[42] || (_cache[42] = 
                                () => {
                                  _ctx.toggleStyles({ textDecoration: 'underline' });
                                }
                              ),
                                    checked: 
                                _ctx.isChecked('textDecoration', 'underline')
                              
                                  }, null, 8, _hoisted_125),
                                  _hoisted_126
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_127, [
                              _hoisted_128,
                              _createElementVNode("div", _hoisted_129, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "color",
                                  class: "form-control",
                                  placeholder: "eg: #f4t498",
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.vzAttributes['color']) = $event)),
                                  onChange: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.vzAttributes['color']]
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_130, [
                          _createElementVNode("div", _hoisted_131, [
                            _createElementVNode("div", _hoisted_132, [
                              _hoisted_133,
                              _createElementVNode("div", _hoisted_134, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "color",
                                  class: "form-control",
                                  placeholder: "eg: #f4t498",
                                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.vzAttributes['backgroundColor']) = $event)),
                                  onChange: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.vzAttributes['backgroundColor']]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_135, [
                              _createElementVNode("div", _hoisted_136, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.vzAttributes['defaultBorder']) = $event)),
                                  onChange: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                                }, null, 544), [
                                  [_vModelCheckbox, _ctx.vzAttributes['defaultBorder']]
                                ]),
                                _hoisted_137
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_138, [
                              _hoisted_139,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.vzAttributes['borderStyle']) = $event)),
                                class: "form-select form-select-solid",
                                "data-placeholder": "Select option",
                                onChange: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                              }, _hoisted_146, 544), [
                                [_vModelSelect, _ctx.vzAttributes['borderStyle']]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_147, [
                              _hoisted_148,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.vzAttributes['borderWidth']) = $event)),
                                class: "form-select form-select-solid",
                                "data-placeholder": "Select option",
                                onChange: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                              }, _hoisted_152, 544), [
                                [_vModelSelect, _ctx.vzAttributes['borderWidth']]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_153, [
                              _hoisted_154,
                              _createElementVNode("div", _hoisted_155, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "color",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.vzAttributes['borderColor']) = $event)),
                                  onChange: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.vzAttributes['borderColor']]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_156, [
                              _createElementVNode("div", _hoisted_157, [
                                _hoisted_158,
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  placeholder: "eg: 10px",
                                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.vzAttributes['padding']) = $event)),
                                  onKeyup: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.vzAttributes['padding']]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_159, [
                                _hoisted_160,
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  placeholder: "eg: 5px",
                                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.vzAttributes['margin']) = $event)),
                                  onKeyup: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.vzAttributes['margin']]
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_161, [
                          _createElementVNode("div", _hoisted_162, [
                            _createElementVNode("div", _hoisted_163, [
                              _hoisted_164,
                              _withDirectives(_createElementVNode("input", {
                                disabled: "",
                                class: "form-control",
                                placeholder: "eg: text1",
                                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.vzAttributes['id']) = $event)),
                                onKeyup: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                              }, null, 544), [
                                [_vModelText, _ctx.vzAttributes['id']]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_165, [
                              _hoisted_166,
                              _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                placeholder: "eg: class1 class2 class3",
                                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.vzAttributes['classes']) = $event)),
                                onKeyup: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                              }, null, 544), [
                                [_vModelText, _ctx.vzAttributes['classes']]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_167, [
                              _createElementVNode("div", _hoisted_168, [
                                _createElementVNode("div", _hoisted_169, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.vzAttributes['required']) = $event)),
                                    onClick: _cache[64] || (_cache[64] = ($event: any) => (
                                _ctx.toggleAttr($event?.target?.checked, 'required')
                              ))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.vzAttributes['required']]
                                  ]),
                                  _hoisted_170
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_171, [
                                _createElementVNode("div", _hoisted_172, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.vzAttributes['readonly']) = $event)),
                                    onClick: _cache[66] || (_cache[66] = ($event: any) => (
                                _ctx.toggleAttr($event?.target?.checked, 'readonly')
                              ))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.vzAttributes['readonly']]
                                  ]),
                                  _hoisted_173
                                ])
                              ])
                            ]),
                            (_ctx.getSelectedComponent?.component == 'CAMERA')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                  _createElementVNode("div", _hoisted_175, [
                                    _createElementVNode("div", _hoisted_176, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.vzAttributes['cameraOnly']) = $event)),
                                        onClick: _cache[68] || (_cache[68] = ($event: any) => (
                                _ctx.toggleAttr(
                                  $event?.target?.checked,
                                  'cameraOnly'
                                )
                              ))
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.vzAttributes['cameraOnly']]
                                      ]),
                                      _hoisted_177
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_178,
                            _createElementVNode("div", _hoisted_179, [
                              _createElementVNode("div", _hoisted_180, [
                                _createVNode(_component_el_select, {
                                  "default-first-option": "",
                                  filterable: "",
                                  placeholder: "Mask",
                                  modelValue: _ctx.vzAttributes['mask'],
                                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.vzAttributes['mask']) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.masks, (mask, i) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: i,
                                        label: mask.text,
                                        value: mask.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _hoisted_181,
                            _createElementVNode("div", _hoisted_182, [
                              _createElementVNode("div", _hoisted_183, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  placeholder: "Validation message",
                                  "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.vzAttributes['maskMessage']) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.vzAttributes['maskMessage']]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_184, [
                              _hoisted_185,
                              _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                placeholder: "points e.g. 12",
                                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.vzAttributes['points']) = $event)),
                                type: "number",
                                nim: "0",
                                onKeyup: _cache[72] || (_cache[72] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                              }, null, 544), [
                                [_vModelText, _ctx.vzAttributes['points']]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_186, [
                              _hoisted_187,
                              _createElementVNode("div", _hoisted_188, [
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "form-control",
                                  rows: "4",
                                  id: "operators-area",
                                  "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.vzAttributes['operation']) = $event)),
                                  onBlur: _cache[74] || (_cache[74] = 
//@ts-ignore
(...args) => (_ctx.applyAttributes && _ctx.applyAttributes(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.vzAttributes['operation']]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_189, [
                              _hoisted_190,
                              _createElementVNode("div", _hoisted_191, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.vzAttributes['type']) = $event)),
                                  class: "form-control",
                                  style: {"width":"100"}
                                }, _hoisted_199, 512), [
                                  [_vModelSelect, _ctx.vzAttributes['type']]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_200, [
                              _hoisted_201,
                              _createElementVNode("div", _hoisted_202, [
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "form-control",
                                  rows: "4",
                                  id: "operators-area",
                                  "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.vzAttributes['expression']) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.vzAttributes['expression']]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_203, [
                              _hoisted_204,
                              _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                placeholder: "e.g. emp does not meet with the configured value, press Yes to cancel it or No for retry",
                                "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.vzAttributes['data']) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.vzAttributes['data']]
                              ])
                            ]),
                            _createVNode(_component_Form, null, {
                              default: _withCtx(() => [
                                (
                            _ctx.getSelectedComponent?.component &&
                            (_ctx.getSelectedComponent.component == 'LIST' ||
                              _ctx.getSelectedComponent.component == 'RADIO_BUTTON')
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "input-group mb-5",
                                          key: index
                                        }, [
                                          _createVNode(_component_Field, {
                                            class: "form-control mb-2 mb-md-0",
                                            modelValue: option.text,
                                            "onUpdate:modelValue": ($event: any) => ((option.text) = $event),
                                            type: "text",
                                            name: `label[${index}]`,
                                            autocomplete: "off",
                                            placeholder: "Label",
                                            onInput: _ctx.applyAttributes
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onInput"]),
                                          _createVNode(_component_Field, {
                                            class: "form-control pr-2 mb-md-0",
                                            modelValue: option.value,
                                            "onUpdate:modelValue": ($event: any) => ((option.value) = $event),
                                            type: "text",
                                            name: `key[${index}]`,
                                            autocomplete: "off",
                                            placeholder: "Value",
                                            onInput: _ctx.applyAttributes
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onInput"]),
                                          _createElementVNode("span", _hoisted_206, [
                                            _createElementVNode("a", {
                                              class: "btn btn-icon btn-primary btn-circle mx-2",
                                              onClick: _cache[78] || (_cache[78] = _withModifiers(
                                  () => {
                                    _ctx.options.push({ text: '', value: '' });
                                  }
                                , ["stop"]))
                                            }, _hoisted_208)
                                          ]),
                                          (_ctx.options.length > 1)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_209, [
                                                _createElementVNode("a", {
                                                  class: "btn btn-icon btn-danger btn-circle",
                                                  onClick: _withModifiers(
                                  () => {
                                    _ctx.options.splice(index, 1);
                                    _ctx.applyAttributes();
                                  }
                                , ["stop"])
                                                }, _hoisted_212, 8, _hoisted_210)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_213, [
                              _createElementVNode("div", _hoisted_214, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-outline btn-outline-primary btn-active-light-primary",
                                  onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.applyAttributes(true)))
                                }, " Apply ")
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.sideBarOption === 'SETTINGS']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_215, [
                    _createElementVNode("div", _hoisted_216, [
                      _hoisted_217,
                      _createElementVNode("div", _hoisted_218, [
                        _createElementVNode("div", _hoisted_219, [
                          _createElementVNode("ul", _hoisted_220, [
                            _createElementVNode("div", _hoisted_221, [
                              _hoisted_222,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "data-kt-user-table-filter": "search",
                                class: "form-control form-control-solid ps-14",
                                placeholder: "Search here...",
                                onKeyup: _cache[80] || (_cache[80] = 
                            () => {
                              if (
                                _ctx.searchTermTemplate.length == 0 ||
                                _ctx.searchTermTemplate.length >= 3
                              )
                                _ctx.getFilteredSection();
                            }
                          ),
                                "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.searchTermTemplate) = $event))
                              }, null, 544), [
                                [_vModelText, _ctx.searchTermTemplate]
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTemplateOptions, (sectionItem) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "list-group-item",
                                key: sectionItem.value,
                                id: sectionItem.value,
                                draggable: true,
                                onDragstart: _cache[83] || (_cache[83] = 
//@ts-ignore
(...args) => (_ctx.handelTemplateDragStart && _ctx.handelTemplateDragStart(...args))),
                                onDragend: _cache[84] || (_cache[84] = 
//@ts-ignore
(...args) => (_ctx.handleTemplateDragEnd && _ctx.handleTemplateDragEnd(...args)))
                              }, [
                                _createElementVNode("div", _hoisted_224, [
                                  _hoisted_225,
                                  _createElementVNode("div", _hoisted_226, [
                                    _createElementVNode("a", {
                                      onClick: _cache[82] || (_cache[82] = _withModifiers(() => {}, ["stop"])),
                                      class: "fw-bolder text-gray-800 text-hover-primary fs-6"
                                    }, _toDisplayString(sectionItem.label), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_227, [
                                    _createElementVNode("a", {
                                      class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#templatePreviewModal",
                                      onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(sectionItem)), ["stop"])
                                    }, _hoisted_230, 8, _hoisted_228)
                                  ])
                                ])
                              ], 40, _hoisted_223))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.sideBarOption === 'TEMPLATES']
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectControl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_231, _hoisted_233))
            : _createCommentVNode("", true),
          _hoisted_234
        ])
      ])
    ]),
    _createVNode(_component_FormSectionModal, {
      viewName: "form_section_modal",
      data: _ctx.selectedSection,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[85] || (_cache[85] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "showDialog"]),
    _createVNode(_component_MobilePreviewModal, {
      data: _ctx.mobilePreviewData,
      onUpdateData: _ctx.updatePreviewData
    }, null, 8, ["data", "onUpdateData"]),
    _createVNode(_component_TabletPreviewModal, {
      data: _ctx.tabletPreviewData,
      onUpdateData: _ctx.updatePreviewData
    }, null, 8, ["data", "onUpdateData"]),
    _createVNode(_component_TemplatePreviewModal, {
      sectionId: _ctx.selectedTemplateId,
      name: _ctx.selectedTemplateName
    }, null, 8, ["sectionId", "name"]),
    _createVNode(_component_ContextMenu, {
      ref: "menu",
      model: _ctx.menuItem
    }, null, 8, ["model"]),
    _createVNode(_component_DropComponentModal, {
      selectedComponent: _ctx.selectedDropElement?.type,
      sectionId: _ctx.sectionId,
      showDialog: _ctx.showModal,
      onCreateElement: _ctx.createElement,
      onOnModalClose: _cache[86] || (_cache[86] = ($event: any) => (_ctx.showModal = false))
    }, null, 8, ["selectedComponent", "sectionId", "showDialog", "onCreateElement"]),
    _createVNode(_component_OverrideTableModal, {
      showDialog: _ctx.showOverrideTableModal,
      onRejectOverRide: _ctx.handleRejectOverRide,
      onConfirmOverRide: _ctx.confirmOverRide
    }, null, 8, ["showDialog", "onRejectOverRide", "onConfirmOverRide"]),
    _createElementVNode("div", _hoisted_235, [
      (_ctx.formStructure.length > 0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[87] || (_cache[87] = _withModifiers(($event: any) => (_ctx.onClickControl('CONTROLS')), ["prevent"])),
            class: _normalizeClass([{ 'bg-selected text-primary': _ctx.sideBarOption === 'CONTROLS' }, "engage-demos-toggle btn btn-flex h-35px bg-body shadow fs-6 pe-4 rounded-top-0"])
          }, _hoisted_238, 2))
        : _createCommentVNode("", true),
      (_ctx.formStructure.length > 0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            onClick: _cache[88] || (_cache[88] = _withModifiers(($event: any) => (_ctx.onClickTemplate('TEMPLATES')), ["prevent"])),
            class: _normalizeClass([{ 'bg-selected text-primary': _ctx.sideBarOption === 'TEMPLATES' }, "engage-demos-toggle btn btn-flex h-35px bg-body shadow fs-6 pe-4 rounded-top-0"])
          }, _hoisted_241, 2))
        : _createCommentVNode("", true),
      (_ctx.formStructure.length > 0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            onClick: _cache[89] || (_cache[89] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openControlSetting && _ctx.openControlSetting(...args)), ["prevent"])),
            class: _normalizeClass(["engage-demos-toggle btn btn-flex h-35px bg-body shadow fs-6 pe-4 rounded-top-0", [
        { disabled: _ctx.getSelectedComponent === undefined },
        { 'bg-selected text-primary': _ctx.sideBarOption === 'SETTINGS' },
      ]])
          }, _hoisted_244, 2))
        : _createCommentVNode("", true)
    ])
  ], 64))
}